export default __webpack_public_path__ + "static/media/Vltava_sm.fe90a8cd.jpg";